/** Word-level IPA overrides for Swedish. */
export const sv: Record<string, string> = {
  ädlaste: '/ˈɛːdlastɛ/',
  ängder: '/ˈɛŋːdɛr/',
  // New entries for updated samples
  anlänt: '/ˈanːlɛnt/',
  arbetsrum: '/ˈarːbetsˌrɵm/',
  arvedel: '/ˈarːveˌdeːl/',
  atenare: '/atɛˈnɑːrɛ/',
  åttiotvå: '/ˈɔtːɪɔˌtvoː/',
  åttitalet: '/ˈɔtːɪˌtɑːlɛt/',
  barnkullarnas: '/ˈbɑːɳˌkɵlːarnas/',
  // New sample overrides
  Birck: '/bɪrk/',
  bönderna: '/ˈbœndɛɳa/',
  brynja: '/ˈbrynːja/',
  bryt: '/bryːt/',
  därnäst: '/ˈdæːɳɛst/',
  dimmors: '/ˈdɪmːɔʂ/',
  eget: '/ˈeːɡɛt/',
  fågelsång: '/ˈfoːɡɛlˌsɔŋː/',
  fjällhöga: '/ˈfjɛlːˌhøːɡa/',
  fjolårets: '/ˈfjuːlˌoːrɛts/',
  fornstora: '/ˈfɔːɳˌstuːra/',
  förtätas: '/fœrˈtɛːtas/',
  fredagskväll: '/ˈfreːdaɡsˌkvɛlː/',
  gamla: '/ˈɡamːla/',
  glädjerika: '/ˈɡlɛdːjɛˌriːka/',
  haga: '/ˈhɑːɡa/', // place name
  halvmörkret: '/ˈhalvˌmœrkrɛt/',
  'hedeby-ön': '/ˈheːdɛbyːˌøːn/', // place name
  henrik: '/ˈhɛnrɪk/', // proper name
  höllo: '/ˈhølːɔ/',
  improvisationer: '/ɪmprɔvɪsaˈɧuːnɛr/',
  Ingmarssönerna: '/ˈɪŋːmarˌsøːnɛɳa/',
  jättestaden: '/ˈjɛtːɛˌstɑːdɛn/',
  kriminalkommissarie: '/krɪmɪˈnɑːlkɔmɪˌsɑːrɪɛ/',
  kristina: '/krɪˈstiːna/', // proper name
  kvällsmörkret: '/ˈkvɛlːsˌmœrkrɛt/',
  långstrump: '/ˈlɔŋːˌstrɵmp/',
  linhårig: '/ˈliːnˌhoːrɪɡ/',
  ljuslågor: '/ˈjʉːsˌloːɡɔr/',
  lövsamlingar: '/ˈløːvˌsamːlɪŋːar/',
  lyfte: '/ˈlʏftɛ/',
  lyftes: '/ˈlʏftɛs/',
  människor: '/ˈmɛnːɪˌɧɔr/',
  människors: '/ˈmɛnːɪˌɧɔʂ/',
  Martin: '/ˈmarːtɪn/',
  mässfall: '/ˈmɛsːˌfalː/',
  mosebacke: '/ˈmuːsɛˌbakːɛ/',
  new: '/njuː/',
  nilsson: '/ˈnɪlːsɔn/', // proper name
  nordamerika: '/ˈnuːɖaˌmeːrɪka/',
  numret: '/ˈnɵmːrɛt/',
  nytt: '/nʏtː/',
  odygd: '/ˈuːˌdyɡd/',
  ofruktsamt: '/ˈuːˌfrɵktsamt/',
  ömtåligare: '/ˈømːˌtoːlɪɡarɛ/',
  öppnad: '/ˈœpːnad/',
  orimligheter: '/uːˈriːmlɪɡˌheːtɛr/',
  oskar: '/ˈɔskar/', // proper name
  page: '/ˈpɑːɧə/',
  päronträd: '/ˈpæːrɔnˌtrɛːd/',
  paulun: '/paˈlʉːn/',
  presentpappret: '/prɛˈsɛntˌpapːrɛt/',
  proportionerad: '/prɔpɔʂɔˈneːrad/',
  roligast: '/ˈruːlɪɡast/',
  rötmånadshetta: '/ˈrøːtˌmoːnadsˌhɛtːa/',
  runor: '/ˈrʉːnɔr/',
  saffransblommorna: '/ˈsafːransˌblɔmːɔɳa/',
  scharlakanssol: '/ˈɧɑːrlakansˌsuːl/',
  si: '/siː/',
  siljan: '/ˈsɪlːjan/',
  silverne: '/ˈsɪlvɛɳɛ/',
  skäms: '/ɧɛmːs/',
  snödropparna: '/ˈsnøːˌdrɔpːaɳa/',
  sommarmorgon: '/ˈsɔmarˌmɔrɡɔn/',
  spiralgalax: '/spɪˈrɑːlɡaˌlaks/',
  tär: '/tɛːr/',
  telefonsamtal: '/tɛlɛˈfoːnˌsamˌtɑːl/',
  tillaga: '/tɪlˈlɑːɡa/',
  tjugosex: '/ˈɕʉːɡɔˌsɛks/',
  uppå: '/ˈɵpːoː/',
  uppgrävda: '/ˈɵpːˌɡrɛːvda/',
  utflyttade: '/ˈʉːtˌflʏtːadɛ/',

  utsiktspunkt: '/ˈʉːtˌsɪktsˌpɵŋkt/',
  välvuxen: '/ˈvɛːlˌvɵksɛn/',
  vanger: '/ˈvaŋːɛr/', // surname
  verklighetsgrund: '/ˈvɛːklɪɡˌheːtsˌɡrɵnd/',
  vilka: '/ˈvɪlːka/',
  vingad: '/ˈvɪŋːad/',
  voro: '/ˈvuːrɔ/',
  york: '/jɔrk/',
  zephyrens: '/sɛˈfyːrɛns/',
};
